export default "/images/flag.svg?661b73f210343a267921723a8ac31b8e";